import React, { Component } from "react";
import image from "../../../../images/orthodonticsimage/HOD.png";
import { NavLink } from "react-router-dom";

export class OrthodonticsSidebar extends Component {
  render() {
    return (
      <div>
        <div className="widget widget-nav-menu">
          <ul className="widget-menu">
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/Orthodontics"}>
                About
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/OrthodonticsFaculties"}>
                Faculties and Staff
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/OrthodonticsTeaching"}>
                Teaching - Learning
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/OrthodonticsResearch"}>
                Research and Innovations
              </NavLink>
            </li>
            <li>
              <NavLink to={process.env.PUBLIC_URL + "/OrthodonticsActivities"}>
                Activities
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="widget">
          <div className="section-title with-desc text-left clearfix">
            <div className="title-header">
              <h2 className="title">
                Head of the <span>department</span>
              </h2>
            </div>
          </div>

          <div className="ttm_single_image-wrapper mb-35 res-991-mb-20">
            <img
              className="d-block w-100"
              src={image}
              alt="Dr Bharath Reddy P"
            />
          </div>

          <h5>Dr. Bharath Reddy P</h5>
          <p>
            Professor & Head of the Department <br /> Orthodontics and
            Dentofacial Orthopaedics
          </p>

          <h6>Education and Qualification:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i>
              BDS: SRM Dental College, Chennai (1997 – 2002)
            </li>
            <li>
              <i className="fas fa-star"></i>
              MDS: Orthodontics and Dentofacial Orthopaedics – Vokkaligara
              Sangha Dental College and Hospital, Bangalore (2003 – 2006)
            </li>
          </ul>

          <br />

          <h6>Work Experience:</h6>
          <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
            <li>
              <i className="fas fa-star"></i> Lecturer (2006 – 2010)
            </li>
            <li>
              <i className="fas fa-star"></i> Associate Professor (2010 – 2018)
            </li>
            <li>
              <i className="fas fa-star"></i> Professor (2018 – 2026)
            </li>
            <li>
              <i className="fas fa-star"></i> Professor & HOD (Till Date)
            </li>
            <li>
              <i className="fas fa-star"></i> Total 20 Years of Teaching
              Experience
            </li>
          </ul>
        </div>
        <div className="widget widget-download">
          <h3 className="widget-title">Contact</h3>
          <ul className="download">
            <li>
              <i className="fa fa-phone" />
              <a> 080-22426705</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default OrthodonticsSidebar;
